const LICENSE_EXPIRATION_MARGIN_DAYS = 15;

const formatDate = (date) => new Intl.DateTimeFormat('en-GB').format(date);

export const getLicenseExpirationNotice = (licenseExpirationDate, translate, currentDate = new Date()) => {
  if (!licenseExpirationDate) return null;

  const expirationDate = new Date(licenseExpirationDate);
  if (Number.isNaN(expirationDate.getTime())) return null;

  const expirationDateWithMargin = new Date(expirationDate);
  expirationDateWithMargin.setDate(expirationDateWithMargin.getDate() + LICENSE_EXPIRATION_MARGIN_DAYS);

  if (currentDate < expirationDate || currentDate > expirationDateWithMargin) return null;

  const expirationMessage = `${translate('license.isExpiring.on.day')} ${formatDate(expirationDate)}.`;
  const blockedMessage = `${translate('viewer.isBlocked.on.day')} ${formatDate(expirationDateWithMargin)}.`;
  const supportMessage = translate('contact.support');

  return `${expirationMessage} ${blockedMessage} ${supportMessage}`;
};
